function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "plan-billet_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  className: "plan-billet_svg__a",
  d: "M0-22h15.037v12H0z",
  transform: "translate(0 22)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "plan-billet_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  className: "plan-billet_svg__b",
  d: "M0 0h15.037v12.252H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "plan-billet_svg__c"
}, /*#__PURE__*/React.createElement("path", {
  className: "plan-billet_svg__a",
  d: "M2.506-22H.5a.5.5 0 00-.5.5v2a.5.5 0 00.5.5.5.5 0 00.5-.5V-21h1.5a.5.5 0 00.5-.5.5.5 0 00-.5-.5",
  transform: "translate(0 22)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "plan-billet_svg__d"
}, /*#__PURE__*/React.createElement("path", {
  className: "plan-billet_svg__b",
  d: "M0-9.748h15.037V-22H0z",
  transform: "translate(0 22)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "plan-billet_svg__e"
}, /*#__PURE__*/React.createElement("path", {
  className: "plan-billet_svg__a",
  d: "M24.106-5.837a.5.5 0 00-.5.5v1.5H22.1a.5.5 0 00-.5.5.5.5 0 00.5.5h2a.5.5 0 00.5-.5v-2a.5.5 0 00-.5-.5",
  transform: "translate(-21.6 5.837)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "plan-billet_svg__g"
}, /*#__PURE__*/React.createElement("path", {
  className: "plan-billet_svg__a",
  d: "M24.106-22h-2a.5.5 0 00-.5.5.5.5 0 00.5.5h1.5v1.5a.5.5 0 00.5.5.5.5 0 00.5-.5v-2a.5.5 0 00-.5-.5",
  transform: "translate(-21.6 22)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "plan-billet_svg__i"
}, /*#__PURE__*/React.createElement("path", {
  className: "plan-billet_svg__a",
  d: "M2.506-3.837H1v-1.5a.5.5 0 00-.5-.5.5.5 0 00-.5.5v2a.5.5 0 00.5.5h2a.5.5 0 00.5-.5.5.5 0 00-.5-.5",
  transform: "translate(0 5.837)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "plan-billet_svg__k"
}, /*#__PURE__*/React.createElement("path", {
  className: "plan-billet_svg__a",
  d: "M3.592-10.407h1.034v-8H3.592z",
  transform: "translate(-3.592 18.408)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "plan-billet_svg__m"
}, /*#__PURE__*/React.createElement("path", {
  className: "plan-billet_svg__a",
  d: "M7.183-12.407h1.035v-6H7.183z",
  transform: "translate(-7.183 18.408)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "plan-billet_svg__o"
}, /*#__PURE__*/React.createElement("path", {
  className: "plan-billet_svg__a",
  d: "M10.775-12.407h1.035v-6h-1.035z",
  transform: "translate(-10.775 18.408)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "plan-billet_svg__q"
}, /*#__PURE__*/React.createElement("path", {
  className: "plan-billet_svg__a",
  d: "M14.367-10.407H15.4v-8h-1.033z",
  transform: "translate(-14.367 18.408)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "plan-billet_svg__s"
}, /*#__PURE__*/React.createElement("path", {
  className: "plan-billet_svg__a",
  d: "M17.959-12.407h1.035v-6h-1.035z",
  transform: "translate(-17.959 18.408)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "plan-billet_svg__u"
}, /*#__PURE__*/React.createElement("path", {
  className: "plan-billet_svg__a",
  d: "M21.55-10.407h1.035v-8H21.55z",
  transform: "translate(-21.55 18.408)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "plan-billet_svg__w"
}, /*#__PURE__*/React.createElement("path", {
  className: "plan-billet_svg__a",
  d: "M7.183-4.864h1.035V-5.9H7.183z",
  transform: "translate(-7.183 5.899)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "plan-billet_svg__y"
}, /*#__PURE__*/React.createElement("path", {
  className: "plan-billet_svg__a",
  d: "M10.775-4.864h1.035V-5.9h-1.035z",
  transform: "translate(-10.775 5.899)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "plan-billet_svg__aa"
}, /*#__PURE__*/React.createElement("path", {
  className: "plan-billet_svg__a",
  d: "M17.959-4.864h1.035V-5.9h-1.035z",
  transform: "translate(-17.959 5.899)"
})), /*#__PURE__*/React.createElement("style", null, ".plan-billet_svg__a,.plan-billet_svg__b{fill:#161a47}.plan-billet_svg__a{clip-rule:evenodd}.plan-billet_svg__g{clip-path:url(#plan-billet_svg__d)}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#plan-billet_svg__a)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#plan-billet_svg__b)"
}, /*#__PURE__*/React.createElement("g", {
  className: "plan-billet_svg__g",
  clipPath: "url(#plan-billet_svg__c)"
}, /*#__PURE__*/React.createElement("path", {
  className: "plan-billet_svg__b",
  d: "M-2.785-2.785h8.577v8.57h-8.577z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(12.029 9.001)",
  clipPath: "url(#plan-billet_svg__e)"
}, /*#__PURE__*/React.createElement("g", {
  className: "plan-billet_svg__g"
}, /*#__PURE__*/React.createElement("path", {
  className: "plan-billet_svg__b",
  d: "M-2.784-2.784h8.577v8.57h-8.577z"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(12.029)",
  clipPath: "url(#plan-billet_svg__g)"
}, /*#__PURE__*/React.createElement("g", {
  className: "plan-billet_svg__g"
}, /*#__PURE__*/React.createElement("path", {
  className: "plan-billet_svg__b",
  d: "M-2.784-2.785h8.577v8.57h-8.577z"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 9.001)",
  clipPath: "url(#plan-billet_svg__i)"
}, /*#__PURE__*/React.createElement("g", {
  className: "plan-billet_svg__g"
}, /*#__PURE__*/React.createElement("path", {
  className: "plan-billet_svg__b",
  d: "M-2.785-2.784h8.577v8.57h-8.577z"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(2 2)",
  clipPath: "url(#plan-billet_svg__k)"
}, /*#__PURE__*/React.createElement("g", {
  className: "plan-billet_svg__g"
}, /*#__PURE__*/React.createElement("path", {
  className: "plan-billet_svg__b",
  d: "M-2.784-2.784h6.608v13.57h-6.6z"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(4.001 2)",
  clipPath: "url(#plan-billet_svg__m)"
}, /*#__PURE__*/React.createElement("g", {
  className: "plan-billet_svg__g"
}, /*#__PURE__*/React.createElement("path", {
  className: "plan-billet_svg__b",
  d: "M-2.785-2.784h6.6v11.57h-6.6z"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(6.001 2)",
  clipPath: "url(#plan-billet_svg__o)"
}, /*#__PURE__*/React.createElement("g", {
  className: "plan-billet_svg__g"
}, /*#__PURE__*/React.createElement("path", {
  className: "plan-billet_svg__b",
  d: "M-2.785-2.784h6.6v11.57h-6.6z"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(8.001 2)",
  clipPath: "url(#plan-billet_svg__q)"
}, /*#__PURE__*/React.createElement("g", {
  className: "plan-billet_svg__g"
}, /*#__PURE__*/React.createElement("path", {
  className: "plan-billet_svg__b",
  d: "M-2.784-2.784h6.6v13.57h-6.6z"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(10.002 2)",
  clipPath: "url(#plan-billet_svg__s)"
}, /*#__PURE__*/React.createElement("g", {
  className: "plan-billet_svg__g"
}, /*#__PURE__*/React.createElement("path", {
  className: "plan-billet_svg__b",
  d: "M-2.785-2.784h6.6v11.57h-6.6z"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(12.002 2)",
  clipPath: "url(#plan-billet_svg__u)"
}, /*#__PURE__*/React.createElement("g", {
  className: "plan-billet_svg__g"
}, /*#__PURE__*/React.createElement("path", {
  className: "plan-billet_svg__b",
  d: "M-2.785-2.784h6.6v13.57h-6.6z"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(4.001 8.967)",
  clipPath: "url(#plan-billet_svg__w)"
}, /*#__PURE__*/React.createElement("g", {
  className: "plan-billet_svg__g"
}, /*#__PURE__*/React.createElement("path", {
  className: "plan-billet_svg__b",
  d: "M-2.785-2.786h6.6v6.6h-6.6z"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(6.001 8.967)",
  clipPath: "url(#plan-billet_svg__y)"
}, /*#__PURE__*/React.createElement("g", {
  className: "plan-billet_svg__g"
}, /*#__PURE__*/React.createElement("path", {
  className: "plan-billet_svg__b",
  d: "M-2.785-2.786h6.6v6.6h-6.6z"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(10.002 8.967)",
  clipPath: "url(#plan-billet_svg__aa)"
}, /*#__PURE__*/React.createElement("g", {
  className: "plan-billet_svg__g"
}, /*#__PURE__*/React.createElement("path", {
  className: "plan-billet_svg__b",
  d: "M-2.785-2.786h6.6v6.6h-6.6z"
})))));

function SvgPlanBillet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.037,
    height: 12
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,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";
export { SvgPlanBillet as ReactComponent };